import {
  Box,
  Paper,
  Typography,
  useTheme
} from '@mui/material';
import React, { FC, useEffect, useMemo } from 'react';
import { BsEye } from 'react-icons/bs';
import { useParams } from 'react-router-dom';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { ImagePreview } from '../../../Components/ImagePreview/image-preview.component';
import { Loader } from '../../../Components/Loader';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { ShowOmieOrderDetailsUseCase } from "../../../Usecase/Orders/show-omie-order-details-usecase";
import { useOmieOrderDetails } from './omie-order-details.hook';

interface IOmieOrderDetailsModalProps {

    showOmieOrderDetailsUseCase: ShowOmieOrderDetailsUseCase
 
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

const OmieOrderDetails : FC<IOmieOrderDetailsModalProps> = ({ showOmieOrderDetailsUseCase  }) => {
   
    const params = useParams()
    const { handleDetailsOmieOrder, loading, omieOrderData, setShowImage, showImage   } = useOmieOrderDetails({
        showOmieOrderDetailsUseCase,
        
    })

  const theme = useTheme()


  const columns = useMemo(() => {
    const createColumns: any[] = [ 
      {
        field: 'photo',
        headerName: 'Imagem',
        renderCell: (params: any) => <Box component='img' src={params?.value?.product?.images[0]?.link} sx={{ width: '80px', height: '80px', objectFit: 'contain'}} />
      },
     
      {
        field: 'product',
        headerName: 'Produto',
        width: 400,
        renderCell: (params: any) => <Box sx={{ height: '100%', display: 'flex', alignItems: 'center'}}><Typography>{params?.row?.product?.name}</Typography></Box>
      },
      
     
     
      // {
      //   field: 'quantity',
      //   headerName: 'Tiragem',
      //   width: 100
      // },
      // {
      //   field: 'product_id',
      //   headerName: 'Produto',
      //   width: 200,
      //   renderCell: (params: any) => <Box sx={{ height: '100%', display: 'flex', alignItems: 'center'}}><Typography>{params?.row?.product?.code}</Typography></Box>
      // },
     
      // {
      //   field: 'card',
      //   headerName: 'Cartela',
      //   width: 100,
      // },
      // {
      //   field: 'created_at',
      //   headerName: 'Data de inclusão',
      //   width: 200,
      //   renderCell: (params: any) => <Box sx={{ height: '100%', display: 'flex', alignItems: 'center'}}><Typography>{format(new Date(data?.startDate), 'dd/MM/yyyy')}</Typography></Box>
      // },
      // {
      //   field: 'substrate',
      //   headerName: 'Substrato',
      //   width: 200,
      // },
      // {
      //   field: 'weight',
      //   headerName: 'Gramatura',
      //   width: 100,
      // },
      // {
      //   field: 'category',
      //   headerName: 'Categoria',
      //   width: 200,
      // },
      // {
      //   field: 'file',
      //   headerName: 'Arquivo',
      //   width: 100,
      // },
      // {
      //   field: 'finalFile',
      //   headerName: 'Arquivo Correto',
      //   width: 300,
      // },
      // {
      //   field: 'dropboxFolder',
      //   headerName: 'Pasta no Dropbox',
      //   width: 300,
      // },
      // {
      //   field: 'status',
      //   headerName: 'Status',
      //   width: 200,
      // },
    ];
  
    return createColumns;
  }, []);

 useEffect(() => {
    handleDetailsOmieOrder(String(params.id))
 }, [])
  
  

  return (
    <>
     {showImage &&  <ImagePreview imageUrl={showImage} onClose={() => setShowImage('')} />}
     <BaseScreen>
            <Paper >
              {loading && <Loader />}

     
              {/* {showDetails &&  kanbanSchema?.columnOrder?.length && <SaleDetailsModal billProductsOrder={billProductsOrder} onClose={() => setShowDetails(undefined)} data={showDetails} fromFinancial type='financial' kanbanSchema={kanbanSchema} canDragProductionKanban={false} canClickProductionKanban={false} canDragFinancialKanban={false} canClickFinancialKanban={true} />} */}

                <BaseContentPage 
                    title='Pedido Omie'
                    breadcrumb={[{ title: 'Pedido Omie', link: "/financial-list"}, { title: 'Listagem'}]}
                    Action={() => <Button LeftIcon={() => <BsEye size={18} />} sx={{ width: '220px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => setShowImage('https://blog.omie.com.br/wp-content/uploads/2022/12/617986bd00bfa05351fb2b0b_jAEOyq8Urndsp56Lz_vUpNpSuWr4w86tBcAEsQ7LNMv3FemKwQEJON0SZ6RSKTfp_geAqymCtapDEZJRtM30g05A-wSEpvBGD65CspGzsXJ_6G-G-WrCEv7tBHZn2rjkMVT0phzM.png')}>Visualizar Nota Fiscal</Button>}
                >
                  {!!omieOrderData?.products?.length ?  <Table 
                    disableRowSelectionOnClick={false} 
                    data={omieOrderData?.products} 
                    totalCount={0} 
                    columns={columns} 
                    sx={{  with: '100%', backgroundColor: theme.palette.background.paper}} 
                    isRowSelectable={() => false}
                    // onSelect={(e: any) => handleConfirmProductionItems(e)} 
                    // onRowClick={(e: any) => handleConfirmProductionItems(e)} 
                    // isRowSelectable={(params: any) => params.row.status !== ServiceOrderStatusEnum.PRODUCED} 
                    /> : <Placeholder description='Nenhum dado encontrado.' /> }

                  
                  
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
     
   
        {/* <Dialog fullScreen open onClose={onClose} sx={{ zIndex: 9999999, backgroundColor: theme.palette.primary.light}}>
        <AppBar position="sticky" sx={{ backgroundColor: '#fff', marginBottom: '20px'}}>
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              {`Pedido Omie: ${data?.omieOriginalOrderId} | Pedido NuvemShop:${data?.nsOrderId}`}
            </Typography>
            <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>

          
        </AppBar> */}

        {/* <Flex justifyContent='flex-end' padding='20px'>
          <Box>
            <Typography>NF - OMIE</Typography>
            
            <img onClick={() => setShowImage('https://blog.omie.com.br/wp-content/uploads/2022/12/617986bd00bfa05351fb2b0b_jAEOyq8Urndsp56Lz_vUpNpSuWr4w86tBcAEsQ7LNMv3FemKwQEJON0SZ6RSKTfp_geAqymCtapDEZJRtM30g05A-wSEpvBGD65CspGzsXJ_6G-G-WrCEv7tBHZn2rjkMVT0phzM.png')} src='https://blog.omie.com.br/wp-content/uploads/2022/12/617986bd00bfa05351fb2b0b_jAEOyq8Urndsp56Lz_vUpNpSuWr4w86tBcAEsQ7LNMv3FemKwQEJON0SZ6RSKTfp_geAqymCtapDEZJRtM30g05A-wSEpvBGD65CspGzsXJ_6G-G-WrCEv7tBHZn2rjkMVT0phzM.png' alt='logo' style={{ width: '200px', height: '300px', objectFit: 'contain', cursor: 'pointer'}} />
          </Box>
          
        </Flex> */}

       

     
     
     
    </>
  );
};


export default OmieOrderDetails

